import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { InfrastructureService } from "../../../infrastructure/shared/services/infrastructure.service";
import { AlertService } from "../../services/alert.service";
import { Indice } from "../../classes/Indice";
import { AbstractControl, FormControl } from "@angular/forms";

@Component({
  selector: 'app-select-indice',
  templateUrl: './select-indice.component.html',
  styleUrls: ['./select-indice.component.css']
})
export class SelectIndiceComponent implements OnInit {
  @Input() pays: string;
  @Input() ind_id: string;
  @Input() control: AbstractControl = new FormControl();
  @Input() lockBase: boolean = false;
  @Input() nombreIndice: number;
  @Input() pourcentageMaxIndice: number;
  @Input() indiceMin: string;
  @Input() mode: 'complet' | 'restreint';
  @Input() state: 
    {base: 'lock'|  'free' | 'hide', indice: 'lock'|  'free' | 'hide', pourcent: 'lock'|  'free' | 'hide'} 
    = {base: 'free', indice: 'free', pourcent: 'hide'};

  @Output() change = new EventEmitter<Indice>();
  @Output() initIndice = new EventEmitter<Indice>();
  @Output() indices_list: EventEmitter<Indice[]> = new EventEmitter<Indice[]>();
  @Output() pourcentageChange = new EventEmitter<number>();

  @ViewChild('pourcentage') pourcentage: ElementRef;
  
  indices: Indice[] = [];
  indicesDisplayed: Indice[] = [];
  bases: string[] = [];
  ind_base: any = null;
  controlBase: AbstractControl = new FormControl();

  constructor(
      private infrastructureService: InfrastructureService,
      private alertService: AlertService
      ) { }

  ngOnInit() {
    this.fetch();
  }

  fetch() {
    this.infrastructureService.fetchIndice(this.pays).subscribe(response => {
      if (response.status === 200) {
        this.indices = response.data.map(elem => 
          new Indice(elem)
        );
        this.indices_list.emit(this.indices);
        this.initForm();

      } else if (response.message) {
        this.alertService.warn(response.message);
      }
    });
  }

  initForm() {
    this.indices.map(elem => {
      if (!this.bases.includes(elem.ind_type)) {
        this.bases.push(elem.ind_type)
      }
    })
    if(this.ind_id == null){
      this.ind_id = '-1';
    }
    if (this.ind_base == null) {
      this.ind_base = "-1";
      this.controlBase.setValue(this.ind_base)
    }
    if (this.controlBase.value == "-1" && this.ind_id != "-1") {
      this.controlBase.setValue(this.searchIndiceById(this.ind_id).ind_type);
      this.ind_base = this.controlBase.value;
      this.onChangeBase(this.ind_base);
    } else {
      this.indicesDisplayed = this.indices;
    }
    if(this.control.value == null){
      this.control.setValue(this.ind_id);
    }

    if (this.ind_id && this.nombreIndice) {
      this.prepareIndices();
    }

    if (this.ind_id) {
      const origine = this.indices.find(i => i.ind_id === this.ind_id);
      this.initIndice.emit(origine);
    }
  }

  compareWith(o1: any, o2: any) {
    return o2 === '-1' && o1 === '-1' || o1 !== '-1' && o2 === o1.ind_id;
  }

  searchIndiceById(ind_id) {
    const indice = this.indices.find(element =>  element.ind_id === ind_id);
    return indice;
  }

  onChange(indice) {
    if (indice !== '-1')
      this.change.emit(indice);
    else
      return this.change.emit(null);
  }

  onChangeBase(base) {
    this.indicesDisplayed = [];
    this.indices.map( elem => {
      if (elem.ind_type === base) {
        this.indicesDisplayed.push(elem);
      }
    });
    if (base === '-1') {
      this.onChange('-1');
    }
  }

  onPourcentageChange(event): void {
    this.pourcentageChange.emit(Number(this.pourcentage.nativeElement.value));
  }

  getIndiceLockedValue(): string {
    if (this.ind_id && this.indices && this.indices.length > 0) {
      const indice = this.indices.find(i => i.ind_id === this.ind_id);
      return indice ? `${indice.ind_date_valeur} ${indice.ind_indice}` : "";
    }

    return "";
  }

  getBaseLockedVAlue(): string {
    return this.ind_base && this.ind_base !== '-1' && this.indices && this.indices.length > 0 ? this.ind_base : 'Base';
  }

  private prepareIndices(): void {
    // On récupère l'objet de l'indice d'origine
    const origine = this.indices.find(i => i.ind_id === this.ind_id);
    // On commence par filtrer les indices antérieurs à l'indices d'origine
    // On obtient un tableau commenceant par l'indice le plus récent jusqu'à l'indice d'origne
    const newIndicesList = this.indicesDisplayed.filter(i=>Number(i.ind_id) >= Number(origine.ind_id));
    // On renvoi l'indices d'origine plus le nombre d'indice souhaité
    const indexStart = (newIndicesList.length - 1 - this.nombreIndice < 0) ? 0 : newIndicesList.length - 1 - this.nombreIndice;  
    this.indicesDisplayed = newIndicesList.slice(indexStart);

    this.onChange(origine);
  }

  isIndiceDisabled(indice: Indice) {
    if (this.indiceMin) {
      let indiceMin = +this.indiceMin;
      return (indiceMin > +indice.ind_id);
    }
    return false;
  }
}
